import customTheme from "../../../theme";

/** Estilos provisionales en login */
const loginStyles = {
  root: {
    height: "100vh",
    width: "100%",
    overflow: "auto",
    backgroundColor: "#082263",
    color: "#47495c",
    alignItems: "center",
    justifyContent: "center",
  },
  imageContainer: {
    [customTheme.breakpoints.only("xs")]: {
      display: "none",
    },
    alignItems: "center",
  },
  logo: {    
    alignItems: "center",
    width:499,
    padding: "0px 32px",
  },
  titleMonitor: {
    fontSize: 32,
    color:"#f4f4f6",
    margin:"16px 0px 16px 0px",
  },
  title: {
    fontSize: 32,
    fontWeight: "bold",
    lineHeight: 1.5,
    letterSpacing: "normal",
    textAlign: "center",
    color: "#082263",
  },
  form: {
    maxWidth: "562px", // Fix IE 11 issue.
    border: "1px solid #ccc",
    backgroundColor: "#e5e6eb",
    alignItems: "center",
  },
  forgotPassword: {
    flexGrow: 1,
    textAlign: "center",
    marginTop: customTheme.spacing(4),
    fontSize: 16,
  },
  cambiarDeSistema: {
    flexGrow: 1,
    textAlign: "center",
    marginTop: customTheme.spacing(4),
    fontSize: 16,
  },
  subtitle: {
    flexGrow: 1,
    textAlign: "center",
    margin: "48px 0px 0px !important"
  },
};

export default loginStyles;
